import { CodigosEstadosFuncionalidades, MetodosCalculoCupo } from "./../../../_enums/enum";
import { PagaduriasCondicionesService } from "./../../../_services/pagadurias-condiciones.service";
import { ConstanteService } from "./../../../_services/constante.service";
import { AutenticacionService } from "./../../../_services/autenticacion.service";
import { NavService } from "./../../../_services/_nav.service";
import { PagaduriaCondicion } from "./../../../_models/pagaduria-condicion";
import { Funcionalidad } from "./../../../_models/funcionalidad";
import {Component, Input, OnInit, Output, ViewChild} from '@angular/core';
import { Table } from "primeng/table";
import { Router } from "@angular/router";
import { forkJoin } from "rxjs";
import { DatePipe } from "@angular/common";
import { DialogService } from "primeng/dynamicdialog";
import { PagaduriaCondicionesEditarComponent } from "../pagaduria-condiciones-editar/pagaduria-condiciones-editar.component";
import { Pagaduria } from "./../../../_models/pagaduria";

@Component({
  selector: "app-pagaduria-condiciones-listado",
  templateUrl: "./pagaduria-condiciones-listado.component.html",
  styleUrls: ["./pagaduria-condiciones-listado.component.css"],
})
export class PagaduriaCondicionesListadoComponent implements OnInit {
  @Input() pagaduria: Pagaduria;
  @Input() detalle = false;
  @Input() rolesFuncionalidad: Funcionalidad = new Funcionalidad();
  pagaduriasCondiones: PagaduriaCondicion[] = [];
  codigoEstadoFuncionalidad = CodigosEstadosFuncionalidades;
  carPagaduriasCondiciones = true;
  carInformacionInicial = true;
  columnas: any[];
  busqueda: string;
  @ViewChild("dt") tabla: Table;
  rolesConfigurados: any;
  verAgregar = false;
  verAprobacionCondicion = false;
  contanteRDUCON: any;
  contanteRDUAPR: any;

  constructor(
    private navServicio: NavService,
    private autServicio: AutenticacionService,
    private constanteService: ConstanteService,
    private router: Router,
    private datePipe: DatePipe,
    private diaService: DialogService,
    private pagaduriasCondicionesService: PagaduriasCondicionesService
  ) { }

  ngOnInit() {
    this.rolesConfigurados = this.autServicio.obtenerRolesUsuarios();
    this.setColumnasTabla();
    this.cargarInformacionInicial();
  }

  cargarInformacionInicial() {
    forkJoin(
      this.constanteService.getByCode("RDUCON"),
      this.constanteService.getByCode("RDUAPR"),
      this.pagaduriasCondicionesService.listadoPorIdPagaduria(this.pagaduria.idPagaduria)
    ).subscribe(([contanteRolConfig, contanteRDUAPR, pagaduriasCondiones]) => {
      this.pagaduriasCondiones = (pagaduriasCondiones).sort(function (a, b) {
        if (a.version > b.version) {
          return -1;
        } else {
          return 1;
        }
      });
      this.contanteRDUCON = contanteRolConfig;
      this.contanteRDUAPR = contanteRDUAPR;
      this.transformarFecha();
      this.validarRolesConfigurados();
      this.setearDescripcionMetodos();
      this.carPagaduriasCondiciones = false;
      this.carInformacionInicial = false;
    });
  }

  transformarFecha() {
    if (this.pagaduriasCondiones.length === 0) {
      return;
    }

    this.pagaduriasCondiones.map((pagaduria) => {
      pagaduria.fechaInicioVigenciaMostrar = this.datePipe.transform(
        pagaduria.fechaInicioVigencia,
        "dd-MM-yyyy"
      );
    });
  }

  setearDescripcionMetodos() {
    if (this.pagaduriasCondiones.length === 0) {
      return;
    }

    this.pagaduriasCondiones.map((pagaduria : PagaduriaCondicion) => {
      switch (pagaduria.codigoMetodo) {
        case MetodosCalculoCupo.METODO1:
          pagaduria.metodoDescripcion =
            "Salario x 50% > SMMLV \n" +
            "Cupo = Salario x " +
            pagaduria.porcentaje1 +
            "  % - Deducciones \n" +
            "Salario x 50% <= SMMLV \n" +
            "Cupo = Salario - Deducciones - (SMMLV x " +
            pagaduria.porcentaje2 +
            " %)";
          break;
        case MetodosCalculoCupo.METODO2:
          pagaduria.metodoDescripcion =
            "Cupo = Salario - Deducciones - (SMMLV x " +
            pagaduria.porcentaje1 +
            " %)";
          break;

        case MetodosCalculoCupo.METODO3:
          pagaduria.metodoDescripcion =
            "Cupo = Salario x " + pagaduria.porcentaje1 + "% - Deducciones";
          break;

        default:
          break;
      }
    });
  }

  validarRolesConfigurados() {
    if (
      !this.contanteRDUCON ||
      !this.contanteRDUAPR ||
      !this.rolesConfigurados
    ) {
      console.log("falta configuracion");
      return;
    }
    const listRoles = this.contanteRDUCON.valor.split(",");
    const listRolesDos = this.contanteRDUAPR.valor.split(",");

    this.verAgregar = this.rolesConfigurados.find(
      (x: any) => x === listRoles.find((y: any) => y === x)
    )
      ? true
      : false;

    this.verAprobacionCondicion = this.rolesConfigurados.find(
      (x: any) => x === listRolesDos.find((y: any) => y === x)
    )
      ? true
      : false;
  }

  setColumnasTabla() {
    this.columnas = [
      {
        field: "version",
        header: this.navServicio.buscarMensaje(
          "PAGADURIACONDICIONES.LBL_VERSION"
        ),
        sort: false,
      },
      {
        field: "fechaInicioVigenciaMostrar",
        header: this.navServicio.buscarMensaje(
          "PAGADURIACONDICIONES.LBL_INICIOVIGENCIA"
        ),
        sort: false,
      },
      {
        field: "aprobacionLibranza",
        header: this.navServicio.buscarMensaje(
          "PAGADURIACONDICIONES.LBL_APROBACIONLIBRANZA"
        ),
        sort: false,
      },
      {
        field: "diaPago",
        header: this.navServicio.buscarMensaje(
          "PAGADURIACONDICIONES.LBL_DIAPAGO"
        ),
        sort: false,
      },
      {
        field: "diaCorte",
        header: this.navServicio.buscarMensaje(
          "PAGADURIACONDICIONES.LBL_DIACORTE"
        ),
        sort: false,
      },
      {
        field: "desfaseAntCorte",
        header: this.navServicio.buscarMensaje(
          "PAGADURIACONDICIONES.LBL_DESFASEANTCORTE"
        ),
        sort: false,
      },
      {
        field: "desfaseDespCorte",
        header: this.navServicio.buscarMensaje(
          "PAGADURIACONDICIONES.LBL_DESFASEDESPCORTE"
        ),
        sort: false,
      },
      {
        field: "metodo",
        header: this.navServicio.buscarMensaje(
          "PAGADURIACONDICIONES.LBL_METODO"
        ),
        sort: false,
      },
      {
        field: "fecha",
        header: this.navServicio.buscarMensaje(
          "PAGADURIACONDICIONES.LBL_FECHA"
        ),
        sort: false,
      },
      {
        field: "hora",
        header: this.navServicio.buscarMensaje("PAGADURIACONDICIONES.LBL_HORA"),
        sort: false,
      },
      {
        field: "usuarioConfigura",
        header: this.navServicio.buscarMensaje(
          "PAGADURIACONDICIONES.LBL_USUARIOCONFIGURA"
        ),
        sort: false,
      },
      {
        field: "usuarioAprueba",
        header: this.navServicio.buscarMensaje(
          "PAGADURIACONDICIONES.LBL_USUARIOAPRUEBA"
        ),
        sort: false,
      },
      {
        field: "estado",
        header: this.navServicio.buscarMensaje(
          "PAGADURIACONDICIONES.LBL_ESTADO"
        ),
        sort: false,
      },
      {
        field: "det",
        header: this.navServicio.buscarMensaje("LBL_ACCIONES"),
        sort: false,
      },
    ];

    this.busqueda = this.navServicio.getSearch(
      "pagadurias-condiciones.component"
    );
  }

  setBusqueda() {
    this.navServicio.setSearch(
      "pagadurias-condiciones.component",
      this.busqueda
    );
  }

  crearPagaduriaCondicion(registro = null, visualizar = false, comparacion = false) {
    const modal = this.diaService.open(PagaduriaCondicionesEditarComponent, {
      header: visualizar
        ? this.navServicio.buscarMensaje(
          "PAGADURIACONDICIONES.LBL_VISUALIZARCONDICIONES"
        )
        : this.navServicio.buscarMensaje(
          "PAGADURIACONDICIONES.LBL_AGREGARCONDICIONES"
        ),
      width: "60%",
      closeOnEscape: false,
      closable: false,
      style: { maxHeight: '90%' },
      data: {
        detalle: visualizar,
        comparacion: comparacion,
        pagaduriaCondicion: registro,
        pagaduria: this.pagaduria,
        listadoPagaduriasCondiciones: this.pagaduriasCondiones
      },
    });
    modal.onClose.subscribe((data) => {
      if (data) {
        this.cargarInformacionInicial();
      }
    });
  }
}
